import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'

import '@/assets/scss/styles.scss'

const productionHosts = ['retirementtaxbill.com', 'dev.retirementtaxbill.com']
const isProductionRoot =
  productionHosts.includes(window.location.hostname) &&
  window.location.pathname === '/' &&
  window.location.search === ''

if (isProductionRoot) {
  window.location.replace('https://www.stonewoodfinancial.com/retirement-tax-bill-funnel')
}

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

const app = createApp(App)

app.use(pinia)
app.use(router)
app.use(vuetify)

router.isReady().then(() => {
  app.mount('#app')
})